import { render, staticRenderFns } from "./DownloadPDF.vue?vue&type=template&id=c8fffe52&scoped=true&"
import script from "./DownloadPDF.vue?vue&type=script&lang=js&"
export * from "./DownloadPDF.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPDF.vue?vue&type=style&index=0&id=c8fffe52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fffe52",
  null
  
)

export default component.exports